<template>
  <el-main class="not-found">
    <img class="center-block logo" data-qa="Content-Logo-Image" src="/src/assets/img/admin-logo.png">
    <el-col :span="8" class="main">
      <div class="title">{{ $t('notFoundTitle') }}</div>
      <div class="description">
        {{ $t('notFoundDescription') }}
      </div>
      <div class="buttons-block">
        <a href="/">
          <el-button type="primary">{{ $t('notFoundButtonHomeText') }}</el-button>
        </a>
        <a :href="goSupportPage">
          <el-button type="primary">{{ $t('notFoundButtonSupportText') }}</el-button>
        </a>
      </div>
    </el-col>
  </el-main>
</template>

<script>
  import main from './NotFound.js'
  export default main
</script>

<style lang="scss" scoped>
  @import './NotFound.scss'
</style>



// WEBPACK FOOTER //
// NotFound.vue?000c4b2d